namespace Gamification.Gamification {
    export interface ProdottiBadgeRow {
        UserId?: number;
        TenantId?: number;
        IdProdottoBadge?: number;
        IdProdotto?: number;
        IdentifierBadge?: string;
        Nome?: string;
        Descrizione?: string;
        ImmagineOttenuto?: string;
        ImmagineOttenutoNomeFile?: string;
        ImmagineNonOttenuto?: string;
        ImmagineNonOttenutoNomeFile?: string;
        IdProdottoIdentifierProdotto?: string;
        IdProdottoNome?: string;
    }

    export namespace ProdottiBadgeRow {
        export const idProperty = 'IdProdottoBadge';
        export const nameProperty = 'Nome';
        export const localTextPrefix = 'Gamification.ProdottiBadge';
        export const lookupKey = 'Gamification.ProdottiBadge';

        export function getLookup(): Q.Lookup<ProdottiBadgeRow> {
            return Q.getLookup<ProdottiBadgeRow>('Gamification.ProdottiBadge');
        }
        export const deletePermission = 'Gamification:Prodotti';
        export const insertPermission = 'Gamification:Prodotti';
        export const readPermission = 'Gamification:Prodotti';
        export const updatePermission = 'Gamification:Prodotti';

        export declare const enum Fields {
            UserId = "UserId",
            TenantId = "TenantId",
            IdProdottoBadge = "IdProdottoBadge",
            IdProdotto = "IdProdotto",
            IdentifierBadge = "IdentifierBadge",
            Nome = "Nome",
            Descrizione = "Descrizione",
            ImmagineOttenuto = "ImmagineOttenuto",
            ImmagineOttenutoNomeFile = "ImmagineOttenutoNomeFile",
            ImmagineNonOttenuto = "ImmagineNonOttenuto",
            ImmagineNonOttenutoNomeFile = "ImmagineNonOttenutoNomeFile",
            IdProdottoIdentifierProdotto = "IdProdottoIdentifierProdotto",
            IdProdottoNome = "IdProdottoNome"
        }
    }
}
